<template>
  <side-panel-inner headerTitle="Reject document">
    <template slot="actions" v-if="!loading">
      <base-button v-if="showBackButton" iconBefore="back" @click="$router.go(-1)">Back</base-button>
      <base-button
        :disabled="!formValid"
        danger
        iconBefore="cross"
        @click="rejectDocument"
      >Submit Rejection</base-button>
    </template>

    <div v-if="!loading">
      <document-meta :document="document"></document-meta>
      <hr>
      <form-field
        label="Reasons for Rejection"
        helper-text="Please give the creator a detailed description of why you are rejecting this document"
        type="textarea"
        v-model="reasons"
        required
        name="reject_reason"
        v-validate="{required: true, min: reasonsMinLength}"
      ></form-field>
    </div>
    <loading v-else></loading>
  </side-panel-inner>
</template>

<script>
import { mapGetters } from 'vuex';

let backButton = false;

export default {
  name: 'document-reject',

  data() {
    return {
      loading: true,
      reasons: '',
      reasonsMinLength: 10,
      showBackButton: backButton,
    };
  },

  beforeRouteEnter(to, from, next) {
    if (from.meta.openPanel) {
      backButton = true;
    } else {
      backButton = false;
    }

    next();
  },

  beforeMount() {
    const vm = this;

    if (vm.$route.params.id) {
      const docId = vm.$route.params.id;
      vm.$store.dispatch('documents/read', docId).then((response) => {
        //
      });
    }

    // so that the background isn't empty...
    if (!this.$store.state.documents[this.$store.state.documents.docType.plural]) {
      this.$store.dispatch('documents/list');
    }

    setTimeout(() => {
      vm.loading = false;
    }, 600);
  },

  methods: {
    rejectDocument() {
      const vm = this;
      const documentId = vm.document.id;
      const versionId = this.$route.params.versionId;

      vm.loading = true;

      vm.$store
        .dispatch('documents/rejectDocument', {
          documentId,
          versionId,
          reason: this.reasons
        })
        .then((response) => {
          vm.$store.dispatch('CLOSE_PANEL');
        });
    },
  },

  computed: {
    ...mapGetters('documents', ['document']),

    formValid() {
      return this.reasons && this.reasons.length >= this.reasonsMinLength;
    },
    versionId() {
      // if there is something in route, use that
      if (this.$route.params.versionId) {
        return this.$route.params.versionId
      }
      //else, fall back to current_version
      if (this.document.current_version) {
        return this.document.current_version.id
      }

      return null;
    }
  },
};
</script>

